export const MIN_WINDOW_Z_INDEX = 100;
export const MIN_WINDOW_WIDTH = 500;
export const MIN_WINDOW_HEIGHT = 300;
export const DEVICE_DETAIL_TAB = 'deviceDetailTab';
export const DEVICE_ATTRIBUTE_DETAIL_TAB = 'deviceAttributesDetailTab';
export const RESOURCE_HIERARCHY_DETAIL_TAB = 'resourceHierarchyDetailTab';
export const PATHLOOKUP_DETAIL_TAB = 'pathLookupDetailTab';
export const PACKET_DETAILS_DETAIL_TAB = 'packetDetailsTab';
export const PATHLOOKUP_DEBUG_DETAIL_TAB = 'pathlookupDebugTab';
export const PATH_INSPECTOR_DETAIL_TAB = 'pathInspectorDetailTab';
export const STP_DETAIL_TAB = 'stpDetailTab';
export const INTENT_CHECK_DETAIL_TAB = 'intentCheckDetailTab';
export const dragTypes = {
  TREE: 'device-view-setup-tree-item',
  TABLE: 'device-view-setup-table-item',
};
export const CONFIRM_CLOSE_DIALOG = 'deviceViewSetupTablesConfirmCloseDialog';
